module.exports = __webpack_public_path__ + "img/0Q3B8222_Foamcore.0c8b2c60.jpg";